import * as React from 'react'
import styles from './TwoColumnsGrid.module.scss'

const TwoColumnsGrid: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className={styles.root}>{children}</div>
)

export default TwoColumnsGrid
